import Layout from './components/layout/layout';
import './App.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import ChatApp from './components/ChatApp/ChatApp';

function App() {

  return (
    <Provider store={store}>
      <div className="App h-full">
        <Layout />
        <ChatApp />
      </div>
    </Provider>
  );
}

export default App;